import React from 'react';

interface Config {
  readonly url: string;
  readonly headers?: any;
  readonly mode?: RequestMode;
}

export const WordPressContext = React.createContext<Config>({
  url: '',
  mode: 'cors',
  headers: {
    'Content-Type': 'application/json',
  },
});

interface Props {
  readonly children: React.ReactNode;
  readonly config: Config;
}

export const WordPressProvider = ({ children, config }: Props) => <WordPressContext.Provider value={config}>{children}</WordPressContext.Provider>;
